import { DestinationAccountControllerType } from "../useDestinationAccount";

import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import { TileContainer } from "./styles";
import { TitleLarge } from "../../../components/font";
import { Button, OptionTile } from "@manifesthhqinc/ui-library";

import HeadingContainer from "../../../layout/heading-container";
import Footer from "../../../components/footer";

const DestinationOptions = (props: DestinationAccountControllerType) => {
  const { userChoice, setUserChoice, onConfirmUserChoice } = props;

  return (
    <TransitionWrapper>
      <ScrollableContainer name="destination-selection">
        <Container>
          <HeadingContainer withProgressBar paneVariant="optionForm">
            <TitleLarge $textAlign="center">Do you know where you want to transfer into?</TitleLarge>
          </HeadingContainer>
          <TileContainer $flexDirection="column" $width="100%">
            <OptionTile
              variant="radioButton"
              appearance="primary"
              supportingText="We’ll help you figure out the best destination option for you."
              onChange={() => setUserChoice("EXPLORE_MY_OPTIONS")}
              name="exploreMyOptions"
              isSelected={userChoice === "EXPLORE_MY_OPTIONS"}
            >
              Explore my options
            </OptionTile>
            <OptionTile
              variant="radioButton"
              appearance="primary"
              supportingText="Provide details for the account you want to transfer into."
              onChange={() => setUserChoice("KNOW_MY_OPTION")}
              name="knowMyDestination"
              isSelected={userChoice === "KNOW_MY_OPTION"}
            >
              I know my destination account
            </OptionTile>
          </TileContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button onClick={onConfirmUserChoice} size="large">
          Continue
        </Button>
        {/* <div className="disclaimer">
          <p>
            The destination options displayed above are for informational purposes only and may not reflect your full
            personal circumstances. They do not constitute investment, tax, or legal advice, nor should they be
            considered a solicitation, offer, or recommendation to buy or sell any security. Use of this application
            does not create an advisor–client or fiduciary relationship. Before deciding whether to roll over a
            retirement account, you should carefully evaluate your personal situation and, where appropriate, consult
            with a qualified financial, tax, or legal professional. Factors to consider may include, but are not limited
            to: investment options, fees and expenses, available services, withdrawal penalties, creditor and legal
            protections, required minimum distributions, and treatment of employer stock. Please see the Participant
            User Agreement and our Terms of Service for additional details.
          </p>
        </div> */}
      </Footer>
    </TransitionWrapper>
  );
};

export default DestinationOptions;
